<template>
  <div class="alerts-panel">
    <h3 class="alerts-panel__title">Alertas <span v-if="alerts.length" class="alerts-panel__count">({{ alerts.length }})</span></h3>

    <div v-if="alerts.length === 0" class="alerts-panel__empty">
      <span class="mdi mdi-check-circle-outline alerts-panel__empty-icon"></span>
      <span class="alerts-panel__empty-text">Todo en orden · Sin alertas activas</span>
    </div>

    <div v-else class="alerts-panel__list">
      <AlertCard
        v-for="alert in visibleAlerts"
        :key="alert.key"
        v-bind="alert"
        @action="$emit('alert-action', alert)"
        @dismiss="$emit('alert-dismiss', alert)"
      />
            <button v-if="limit && alerts.length > limit" class="alerts-panel__view-all" @click="$emit('view-all')">
        Ver todas las alertas ({{ alerts.length }})
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import AlertCard from './AlertCard.vue'

const props = defineProps({
  alerts: { type: Array, default: () => [] },
  // Sin límite por default (para usarse como la vista "todas las alertas");
  // se le pasa un número cuando se quiere un panel compacto.
  limit: { type: Number, default: null },
})

defineEmits(['alert-action', 'alert-dismiss', 'view-all'])

const visibleAlerts = computed(() => (props.limit ? props.alerts.slice(0, props.limit) : props.alerts))
</script>

<style scoped>
.alerts-panel {
  background: var(--bg-surface-1);
  border: 1px solid var(--border-active);
  border-radius: 10px;
  padding: 1rem 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 100%;
  min-height: 0;
}

.alerts-panel__title {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-content);
  font-family: var(--font-body);
}

.alerts-panel__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem 0.5rem;
  text-align: center;
}

.alerts-panel__empty-icon {
  font-size: 1.6rem;
  color: var(--accent-green);
}

.alerts-panel__empty-text {
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.alerts-panel__list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.alerts-panel__list::-webkit-scrollbar {
  width: 6px;
}

.alerts-panel__list::-webkit-scrollbar-thumb {
  background: var(--border-active);
  border-radius: 3px;
}

.alerts-panel__list::-webkit-scrollbar-track {
  background: transparent;
}

.alerts-panel__view-all {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0.3rem 0;
  text-align: left;
}

.alerts-panel__count {
  color: var(--text-secondary);
  font-weight: 400;
}

.alerts-panel__view-all:hover {
  color: var(--text-primary);
}
</style>